import {
  faStar,
  faUsers,
  faEnvelope,
  faWallet,
  faUser,
  faCog,
  faCertificate,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";

export const getSidebarMenus = (currentUserId) => [
  {
    key: "prime",
    label: "Prime",
    icon: faStar,
    path: "/feed/prime",
  },
  {
    key: "public",
    label: "Public",
    icon: faUsers,
    path: "/feed/public",
  },
  {
    key: "revolution",
    label: "Revolution",
    icon: faEnvelope,
    children: [
      {
        key: "revolution-create",
        label: "Create Revolution",
        path: "/revolution/create",
      },
      {
        key: "revolution-all",
        label: "All Revolution",
        path: "/revolution/all",
      },
      {
        key: "revolution-my",
        label: "My Revolution",
        path: "/revolution/my",
      },
    ],
  },
  {
    key: "wallet",
    label: "Wallet",
    icon: faWallet,
    path: "/wallet",
  },
  {
    key: "profile",
    label: "Profile",
    icon: faUser,
    path: `/my/${currentUserId}/profile`,
  },
  {
    key: "support",
    label: "Support",
    icon: faUserCheck,
    path: `/support-chat`,
  },
  // {
  //   key: "certificate",
  //   label: "Certificate",
  //   icon: faCertificate,
  //   path: `/certificate`,
  // },
  {
    key: "settings",
    label: "Settings",
    icon: faCog,
    children: [
      { key: "kyc", label: "KYC", path: "/kyc" },
      {
        key: "aadhaar",
        label: "Verification",
        path: "/aadhaar-verification",
      },
      { key: "blocked", label: "Blocked user", path: "/blocked-user" },
      // { key: "donation", label: "Donation", path: "/donation" },
      {
        key: "deactive-profile",
        label: "Deactive Profile",
        path: "/deactive-profile",
      },
      {
        key: "delete-account",
        label: "Delete Account",
        path: "/delete-account",
      },
      {
        key: "privacy-policy",
        label: "Privacy Policy",
        path: "/privacy-policy",
      },
    ],
  },
];
